import { useState } from 'react';
import { Bell, BellOff, Loader2 } from 'lucide-react';
import { useWebPush, shouldPromptWebPush } from '@shared/messaging/useWebPush';

export default function WebPushPrompt() {
  const [dismissed, setDismissed] = useState(false);
  const { isSupported, isSubscribed, isLoading, error, subscribe, unsubscribe } = useWebPush();

  if (!isSupported || dismissed) {
    return null;
  }

  if (isSubscribed) {
    return (
      <div className="mb-4 flex items-center justify-between gap-3 rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-900">
        <div className="flex items-center gap-2">
          <Bell className="h-4 w-4" />
          <span>Message notifications are enabled for this browser.</span>
        </div>
        <button
          type="button"
          onClick={() => unsubscribe()}
          disabled={isLoading}
          className="text-xs font-medium text-emerald-800 hover:text-emerald-950"
        >
          Turn off
        </button>
      </div>
    );
  }

  if (!shouldPromptWebPush()) {
    return null;
  }

  return (
    <div className="mb-4 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 flex h-9 w-9 items-center justify-center rounded-xl bg-primary-100 text-primary-700">
          <Bell className="h-4 w-4" />
        </div>
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-900">Get notified when the office replies</p>
          <p className="mt-1 text-xs text-gray-500">
            Enable browser notifications so you don&apos;t miss messages when this tab is in the background.
          </p>
          {error && <p className="mt-2 text-xs text-red-600">{error}</p>}
          <div className="mt-3 flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => subscribe()}
              disabled={isLoading}
              className="btn btn-primary btn-sm"
            >
              {isLoading ? <Loader2 className="h-4 w-4 animate-spin" /> : 'Enable notifications'}
            </button>
            <button
              type="button"
              onClick={() => setDismissed(true)}
              className="btn btn-secondary btn-sm"
            >
              Not now
            </button>
          </div>
        </div>
        <button type="button" onClick={() => setDismissed(true)} className="text-gray-400 hover:text-gray-600">
          <BellOff className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
